import React from "react";
import Title from "../Typography/Title";
import WorksCardsX from "../Cards/WorksCardsX";
import Marquee from "react-fast-marquee";
import image1 from "../images/sample-section-img/sample-1.png";
import image2 from "../images/sample-section-img/sample-2.png";
import image3 from "../images/sample-section-img/sample-3.png";
import image4 from "../images/sample-section-img/sample-4.png";
import image5 from "../images/sample-section-img/sample-5.png";
import image6 from "../images/sample-section-img/sample-6.png";
import image7 from "../images/sample-section-img/sample-7.png";
import image8 from "../images/sample-section-img/sample-8.png";
import image9 from "../images/sample-section-img/sample-9.png";
import image10 from "../images/sample-section-img/sample-4.png";

export default function ThingsWeHaveMade() {
  const images = [image1, image2, image3, image4, image5, image6, image7, image8, image9,image10]; // Add the images here.

  return (
    <div className="flex flex-col items-center justify-center relative">
      <div className="rounded-[700px] top-0 left-0 bg-gradient-to-r rotate-90 from-[#00c3ffdb] to-[#FF29C3] absolute h-[500px] w-[500px] blur-[250px]"></div>
      <Title title={"Things We've Made"} miniTitle={"Work"} />
      <p className="text-[rgb(187,187,187)] font-thin text-base md:text-xl font-poppins p-5 md:max-w-[33%] text-center pt-4 tracking-wide">
        We help our clients grow their bottom-line with clear and professional
        websites.
      </p>
      <div className="pt-16 z-10 w-full">
        <Marquee gradient={false} speed={50} pauseOnHover={false}>
          <div className="flex flex-col space-y-8">
            {/* First row */}
            <div className="flex  space-x-4">
              {images.slice(0, 5).map((img, index) => (
                <div
                  key={index}
                  className={`transition-all duration-300 mx-4 ${
                    index % 4 === 0 || index % 4 === 2 ? "md:pt-24" : "pt-0"
                  }`}
                >
                  <WorksCardsX img={img} />
                </div>
              ))}
            </div>

            {/* Second row */}
            <div className="flex  space-x-4">
              {images.slice(5, 10).map((img, index) => (
                <div
                  key={index}
                  className={`transition-all duration-300 mx-4 ${
                    index % 4 === 0 || index % 4 === 2 ? "md:pt-24" : "pt-0"
                  }`}
                >
                  <WorksCardsX img={img} />
                </div>
              ))}
            </div>
          </div>
        </Marquee>
      </div>
    </div>
  );
}
